import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import Page from "../../components/Page";
import { Checkbox, Loader, MultiSelect, Select, Slider } from "@mantine/core";
import "./styles.css";
import EmployeeCard from "./EmployeeCard";
import ads from "../../assets/home.gif";
import { backendUrl } from "../../constants";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../components/inputField";
import CompleteProfile from "../../components/CompleteProfile";

const Index = ({ t }) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("userData"));
  const [skills, setSkills] = useState([]);
  const { keyword, location } = useParams();

  // const [distance, setDistance] = useState("5");
  const [edu, setEdu] = useState([]);
  const [exp, setExp] = useState([]);
  const [loc, setLoc] = useState([]);
  const [emp, setEmp] = useState([]);
  const [jobSeekers, setJobSeekers] = useState([]);
  const [filters, setFilters] = useState({page:'1', size:'50'});
  const [loading, setLoading] = useState(false);

  //location
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}empLocation/listEmpLocation`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.locationName };
          setLoc((loc) => [...loc, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //education
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/education`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setEdu((edu) => [...edu, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //experience
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/experience`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setExp((exp) => [...exp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //employment type
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/jobType`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setEmp((emp) => [...emp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //Skills
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}skill/listSkill`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.skillName };
          setSkills((skill) => [...skill, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //filters
  useEffect(() => {
    setLoading(true);
    setJobSeekers([]);
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(filters),
    };
    fetch(`${backendUrl}user/searchJobSeeker`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            key: obj._id,
            title: obj.displayName,
            role: obj.jobSeeker[0]?.jobTitle,
            skills: obj.jobSeeker[0]?.jobSeekerSkills
              .map((obj) => obj.skills.skillName)
              .join(", "),
            description: obj.jobSeeker[0]?.summary,
          };
          setJobSeekers((jobseeker) => [...jobseeker, a]);
        });
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  }, [filters]);

  const clearSearch = () => {
    if (location || keyword) {
      navigate("/employer/searchJobSeeker");
    }
    window.location.reload();
  };

  return (
    <Page className="landing-page">
      <div className="searchMain1">
        <h2 className="text-dark mb-0 mt-2">Search Job Seeker</h2>
        <div className="searchMain">
          <div className="filters">
            <div className="">
              <p style={{ margin: "0px", fontWeight: "500" }}>
                Keyword or Name
              </p>
              <InputField
                placeholder="Enter Name"
                style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
                onBlur={(v) =>
                  setFilters((filters) => ({
                    ...filters,
                    displayName: v.target.value,
                  }))
                }
              />
            </div>
            <MultiSelect
              label="Skills"
              placeholder="skills..."
              data={skills}
              searchable
              maxDropdownHeight={400}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, empLocation: v }))
              }
            />
            <Select
              label="Location"
              placeholder="Location..."
              data={loc}
              searchable
              creatable
              maxDropdownHeight={400}
              getCreateLabel={(query) => `${query}`}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, empLocation: v }))
              }
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim())
              }
            />
            <Select
              label="Education"
              placeholder="Any..."
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, education: v }))
              }
              data={edu}
              maxDropdownHeight={400}
              nothingFound="Nothing here"
            />
            <Select
              label="Experience"
              placeholder="Any..."
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, experience: v }))
              }
              data={exp}
              maxDropdownHeight={400}
              nothingFound="Nothing here"
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim()) ||
                item.description
                  .toLowerCase()
                  .includes(value.toLowerCase().trim())
              }
            />
            <Checkbox.Group
              label="Job Type"
              size="xs"
              onChange={(v) =>
                setFilters((filters) => ({
                  ...filters,
                  jobType: v.join(","),
                }))
              }
            >
              <div className="d-flex w-100 row justify-content-between">
                {emp &&
                  emp.map((obj, key) => (
                    <Checkbox
                      classNames="col-md-6"
                      key={key}
                      value={obj.value}
                      label={obj.label}
                      className="w-50"
                      color="red"
                    />
                  ))}
              </div>
            </Checkbox.Group>
            <Button
              title={"Clear Search"}
              icon={"cross"}
              primary={true}
              fontWeight="700"
              type="submit"
              onClick={clearSearch}
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                fontSize: "12px",
                marginTop: "10px",
              }}
            />
          </div>
          {loading ? (
            <Loader
              size="xl"
              color="red"
              className="text-center"
              style={{ margin: "auto" }}
            />
          ) : (
            <div className="jobs">
              {jobSeekers.length < 1 ? (
                <h2 className="text-dark text-center">No People Found.</h2>
              ) : (
                jobSeekers?.map((obj, key) => (
                  <EmployeeCard data={obj} key={key} />
                ))
              )}
            </div>
          )}
          <div className="w-25 mob-s">
            <CompleteProfile />
            <img src={ads} className="adimage1 mt-3" />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
